import {Component, forwardRef, Injector, Input, OnInit} from "@angular/core";
import {StockCostingType} from "../stock-costing-type";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => StockCostingTypeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-stock-costing-type-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR
    ]
})
export class StockCostingTypeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> implements OnInit {
    @Input() allowCustomCost: boolean = false;

    constructor(injector: Injector) {
        super(undefined, injector);
        this.allowClearSelectionOption = false;
    }

    override ngOnInit(): void {
        const options: { label: string, value: StockCostingType }[] = [
            {label: "wbo.stock.option.costing-type.lastCost", value: StockCostingType.LAST_COST},
            {label: "wbo.stock.option.costing-type.currentCost", value: StockCostingType.CURRENT_COST},
            {label: "wbo.stock.option.costing-type.averageCost", value: StockCostingType.AVERAGE_COST}
        ];
        if (this.allowCustomCost) {
            options.push({label: "wbo.stock.option.costing-type.customCost", value: StockCostingType.CUSTOM_COST});
        }
        this.buildData(options);

        super.ngOnInit();
    }
}
